import React, { useEffect, useState } from 'react';
import './header.css';
import { MdOutlineMenuOpen } from 'react-icons/md';
import Sidebar from '../Sidebar/Sidebar';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../hooks/UseAuthContext';
import { useLogout } from '../../hooks/UseLogout';
import api from '../../api';

function Header() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [initials, setInitials] = useState('');
  const { user } = useAuthContext();
  const { logout } = useLogout();

  useEffect(() => {
    if (!user) return;

    api.get('/get-user')
      .then((response) => {
        setUserData(response.data);
        console.log(response.data)
        const first = response.data.firstName?.[0] || '';
        const last = response.data.lastName?.[0] || '';
        setInitials(`${first}${last}`.toUpperCase());
      })
      .catch((error) => {
        console.error('Error fetching user data:', error);
      });
  }, [user]);

  return (
    <>
      {/* Sidebar */}
      {sidebarOpen && <Sidebar setSideBar={setSidebarOpen} />}

      {/* Header */}
      <header className="header">
        {/* Menu Button */}
        <div className="side-bar-icon">
          <button
            className="menu-button"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
            aria-expanded={sidebarOpen}
          >
            <MdOutlineMenuOpen />
          </button>
        </div>

        {/* Logo */}
        <div className="logo">
          <Link to="/" aria-label="Home - Alchemy Mix">
            <div className="logo-badge" aria-hidden="true" />
            <h2>Alchemy Mix</h2>
          </Link>
        </div>

        {/* User Section */}
        <div className="header-items">
          {/* User Avatar */}
          {initials && (
            <div
              className="name"
              title={userData ? `${userData.firstName} ${userData.lastName}` : 'User Profile'}
              role="button"
              tabIndex={0}
              aria-label={`User profile: ${initials}`}
            >
              <p>{initials}</p>
              {/* Optional: Add status indicator */}
              {/* <span className="status-indicator" aria-label="Online" /> */}
            </div>
          )}

          {/* Logout Button */}
          <div className="logout">
            <button onClick={logout} aria-label="Logout">
              <span>Logout</span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;